import { CommonModule } from '@angular/common';
import type { OnInit } from '@angular/core';
import { LazyImgDirective } from '@core-mkt/services/lazy-load/lazy-load.directive';
import { Component, Input } from '@angular/core';
import { BrandConfigurationService } from '@core-mkt/services/configuration/brand-configuration.service';
import { EnvService } from '@core-mkt/services/env/env.service';
import { TrustpilotService } from '@core-mkt/services/trustpilot/trustpilot.service';
import { TopSection } from '../top-section';

@Component({
  selector: 'top-section-trustpilot',
  templateUrl: './top-section-trustpilot.component.html',
  standalone: true,
  imports: [CommonModule, LazyImgDirective],
})
export class TopSectionTrustpilotComponent implements OnInit {
  @Input() data: TopSection;
  private trustpilotBrandUrl: string;
  trustpilotVerified = false;
  trustpilotTrustScore: number;
  trustpilotNumberOfReviews: number;

  constructor(private bcs: BrandConfigurationService, private env: EnvService, private tps: TrustpilotService) {
    this.trustpilotBrandUrl = `https://www.trustpilot.com/review/${this.bcs.url}`;
  }

  ngOnInit(): void {
    if (this.data.showTrustpilotStars && this.env.get.brandConfig.trustpilotId.length > 0) {
      void this.tps.getBrandStarsRating().then((trustPilotRating) => {
        if (!trustPilotRating) return;
        this.trustpilotTrustScore = trustPilotRating.score.trustScore;
        this.trustpilotNumberOfReviews = trustPilotRating.numberOfReviews.total;
        this.checkTrustpilotStars();
      });
    }
  }

  private checkTrustpilotStars(): void {
    if (this.trustpilotNumberOfReviews) {
      this.trustpilotVerified = true;
    }
  }

  openTrustpilot(): void {
    this.tps.openTrustpilot(this.trustpilotBrandUrl);
  }
}
